import { render, staticRenderFns } from "./Honorarliste.vue?vue&type=template&id=5c480b4c&"
import script from "./Honorarliste.vue?vue&type=script&lang=js&"
export * from "./Honorarliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports